import {
  ICreateCreditMemoBatchRepository,
  ICreateCreditMemoBatchRepositoryParams,
  ICreateCreditMemoBatchRepositoryResponse,
} from "@/core/repositories/accounting";

export class CreateCreditMemoBatchUseCase {
  constructor(private readonly repository: ICreateCreditMemoBatchRepository) {}

  async execute(
    params: ICreateCreditMemoBatchRepositoryParams
  ): Promise<ICreateCreditMemoBatchRepositoryResponse> {
    return this.repository.createCreditMemoBatch(params);
  }
}
